import React from "react";
import Preview from "../views/Preview";
import HomeOne from "../views/all-home-version/HomeOne";
import HomeTwo from "../views/all-home-version/HomeTwo";
import HomeThree from "../views/all-home-version/HomeThree";
import HomeFour from "../views/all-home-version/HomeFour";
import NotFound from "../views/NotFound";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

const Routes = () => {
  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/" component={HomeTwo} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    </>
  );
};

export default Routes;
